import { styled } from "../../../../styles";

// Relative wrapper so the (absolutely positioned) filter popover anchors to
// the button.
export const ControlWrapper = styled("div", {
  position: "relative",
  display: "inline-flex",
});
